export const documentPermissionKeys = {
  forDocument: (documentSuperId: number | string) => ['document-permissions', documentSuperId],
};
